import React from "react";
import { Alert, Paper, Stack, TextField, Typography } from "@mui/material";
import RowTypeField from "./RowTypeField";

function SectionHeader({ title, description }) {
  return (
    <Stack spacing={0.5}>
      <Typography variant='subtitle1' fontWeight={700}>
        {title}
      </Typography>
      <Typography variant='body2' color='text.secondary'>
        {description}
      </Typography>
    </Stack>
  );
}

const sectionPaperSx = {
  p: 2.5,
  display: "grid",
  gap: 2,
  borderRadius: 2,
};

export default function NewScheduleForm({
  selectedScheduleType,
  register,
  control,
  errors,
  companyType,
  isRowTypeDisabled,
  rowTypeRequired,
  editMode,
  row,
}) {
  return (
    <Paper variant='outlined' component='section' sx={sectionPaperSx}>
      <SectionHeader
        title='Create a new schedule'
        description={`Add a new ${selectedScheduleType} schedule and bind this row to it.`}
      />

      {editMode && row?.schedule && (
        <Alert severity='info'>
          Currently tagged to <strong>{row.schedule.scheduleTitle}</strong>{" "}
          (Schedule No. {row.schedule.scheduleNo}). Creating a new schedule will
          replace the current tag.
        </Alert>
      )}

      <Stack spacing={2}>
        <TextField
          {...register("scheduleTitle", {
            required: "Please enter a schedule title.",
          })}
          fullWidth
          label='Schedule Title'
          placeholder='Enter a title for the new schedule'
          size='small'
          disabled={[
            "Allocation Of Expenses",
            "Renovation Schedule",
            "FAAdditions",
          ].includes(selectedScheduleType)}
          error={Boolean(errors.scheduleTitle)}
          helperText={errors.scheduleTitle?.message || ""}
        />

        <RowTypeField
          selectedScheduleType={selectedScheduleType}
          control={control}
          errors={errors}
          companyType={companyType}
          disabled={isRowTypeDisabled}
          required={rowTypeRequired}
        />
      </Stack>
    </Paper>
  );
}
